import React from 'react';
import { Helmet } from 'react-helmet-async';
import '../../styles/HomeComponents/TermsConditions.css'; // You can create this CSS file for styling

const TermsConditions = () => {
  const SITE_URL = process.env.REACT_APP_SITE_URL;
  return (

      <>
        <Helmet>
          <title>Strawket Terms & Conditions – User Agreement</title>
          <meta
            name="description"
            content="Review Strawket’s terms of use, user responsibilities, and platform policies. Understand your rights and obligations before using our services or registering."
          />
          <meta
            name="keywords"
            content="Strawket terms, conditions, terms of use, policies, user agreement, legal guidelines"
          />
          <link rel="canonical" href="https://strawket.com/terms-conditions" />
    
          {/* Open Graph Meta */}
          <meta property="og:title" content="Terms & Conditions | Strawket" />
          <meta
            property="og:description"
            content="Understand the rules, rights, and responsibilities when using the Strawket platform. View our updated Terms and Conditions."
          />
          <meta property="og:url" content={`${SITE_URL}/terms-conditions`} />
          <meta property="og:type" content="article" />
    
          {/* Twitter Meta */}
          <meta name="twitter:title" content="Terms & Conditions | Strawket" />
          <meta
            name="twitter:description"
            content="Learn more about the legal usage of Strawket through our Terms & Conditions. Stay informed about your rights and obligations."
          />
          <meta name="twitter:card" content="summary" />
        </Helmet>


    <div className="terms-conditions-container">
      <div className="terms-conditions-box">
        <h2 style={{ textAlign: "center" }}>
      STRAWKET LEARNING INC. WEBSITE TERMS OF USE
    </h2>

    <p><strong>Last updated:</strong> December 16, 2025</p>

    <h3>OVERVIEW</h3>
    <p>
      These Terms of Use form a legally binding contract between STRAWKET LEARNING INC. ("we" or "us") and the people and companies (“Users” or “you”) that access and use our website located at www.strawket.com or any related website or mobile platform controlled by us (collectively, the "Website"). These Terms of Use apply to all services provided through our Website and any other software application we operate, and all content, services, and products available at or through the Website.
    </p>

    <p>
      It is very important that you read and fully understand these Terms of Use before using the Website. By agreeing to these Terms of Use and using the Website, you are entering into a legally binding contract which will impact your rights.
    </p>

    <p>By accessing any part of the Website, you agree to be bound by these Terms of Use. You are also confirming that you have read and fully understood these Terms of Use. If you do not agree to or understand all of these Terms of Use, then you may not access the Website or use any services available on the Website.
    </p>
    <p>
      These Terms of Use should be read in conjunction with the Privacy Policy and any other rules, guidelines, or policies posted on the Website.
    </p>

    <h3>SERVICES AVAILABLE ON THE WEBSITE</h3>
    <p>
      Without restriction, we generally offer the following services through the Website:
    </p>
    <ul>
      <li>Strawket is a learning platform that provides administration and marketing services to educators and academies. The platform also serves as a place to discover courses, educators and academies for learners.</li>
    </ul>
    <p>
      The services we offer are subject to change over time. By using the Website, you are confirming that you have determined that the services are appropriate for your needs. We do not guarantee that these services meet your needs or that they are suitable for your specific purposes.
    </p>

    <h3>OWNERSHIP OF YOUR FILES</h3>
    <p>
      When you choose to upload documents or data (including any images or text), STRAWKET LEARNING INC. does not review or pre-screen the contents of electronic data uploaded or posted to the Website (“Content”) and STRAWKET LEARNING INC. claims no intellectual property rights with respect to the Content.
    </p>
    <p>
      However, by posting, uploading, inputting or submitting any Content whatsoever to the Website, you are granting STRAWKET LEARNING INC. an irrevocable, royalty free licence while the Content remains uploaded to the Website, to use the Content for any purpose related to the use and promotion of its business and the Website, including the right to copy, distribute, edit, and publicly display such content with or without attribution.
    </p>

    <h3>PAYMENT PROCEDURES</h3>
    <p>
      Payments for services or products available on the Website will be charged to you in accordance with the policies, procedures, and timelines posted on the relevant sections of the Website.
    </p>
    <p>
      You agree to pay the fees applicable to your subscription and any other applicable fees, including but not limited to fees relating to the processing of transactions under your account (“Fees”).
    </p>
    <p>
      All initial and recurring Fees will be charged to the credit card that you authorize for your account. It is your responsibility to keep your authorized credit card valid and up to date at all times. We may terminate or block access to your account if your credit card becomes expired or otherwise invalid at the time any Fees become due.
    </p>
    <p>
      For purposes of processing payments, we use the following service provider:
    </p>
    <p>
      STRIPE
    </p>
    <p>
      Before using the Website, you must first review and approve the terms andconditions governing the use of these third-party payment processors, which areavailable at the following website(s): https://www.stripe.com
    </p>

    <h3>YOUR ACCOUNT</h3>
    <p>
      In order to fully use the Website, you will be required to create an account. Information submitted by you in order to create an account will be subject to our Privacy Policy, which is available for review on the Website, and which you are required to approve before creating an account. The Privacy Policy also dictates how to terminate your account and how you can have your personal identifying information deleted from our servers.
    </p>
    <p>
      The terms governing the features and capabilities of your account and the related fees can be found on the Website.
    </p>

    <h3>TERMINATION</h3>
    <p>
      You may cancel and terminate your Account at any time in accordance with the terms and policies posted on the Website.
    </p>
    <p>
      If at the date of termination of your Account, there are any outstanding payments owing by you to us, you will receive one final invoice via email. Once that invoice has been paid in full, you will not be charged again.
    </p>

    <h3>LIMITATION OF LIABILITY</h3>
    <p>
      Except in a case where we are in violation of these Terms of Use, we will not beheld liable for, and you hereby fully waive the right to claim for, any loss, injury,claim, liability or damages of any kind resulting in any way from use of the Website. 
    </p>
    <p>
      Your use of the Website is at your sole risk. The Website is provided on an “as is”and “as available” basis without any warranty or condition, express, implied or statutory. We do not warrant that your use of the Website will be uninterrupted,secure or error-free.
    </p>
    <p>
      In no event will we have any liability to you or any third party for any lost profitsor revenues or for any indirect, special, incidental, consequential, or punitive damages however caused, whether in contract, tort, or otherwise, and whetheror not you or the third party have been advised of the possibility of such damages. In the event the foregoing paragraph, or any part thereof, is void under applicable law, this paragraph, or such part thereof, shall be inapplicable.
    </p>

    <h3>INDEMNIFICATION</h3>
    <p>
      You agree to indemnify and hold harmless STRAWKET LEARNING INC., including our officers, directors, shareholders, employees and agents, from and against any and all claims and expenses, including legal fees and disbursements, which are made against us and arise out of your use of the Website, including but not limited to your violation of any term of these Terms of Use or any other policy posted on the Website.
    </p>

    <h3>SECURITY BREACHES</h3>
    <p>
      In order to protect your security, it is your sole responsibility to ensure that all usernames and passwords used to access the Website are kept secure and confidential.
    </p>

    <p>
      You must immediately notify us of any unauthorized use of your account,including the unauthorized use of your password, or any other breach of security.
    </p>
    <p>
      We will investigate any breach of security on the Website that we determine in our sole discretion to be serious in nature, but we will not be held responsible or liable in any manner for breaches of security or any unauthorized access to your account however arising.
    </p>
    

    <h3>WARRANTIES AND REPRESENTATIONS</h3>
    <p>
      We hereby disclaim all warranties of any kind, whether express, implied, or statutory, including but not limited to implied warranties as to merchantability or fitness for a particular purpose as they relate to the Website.
    </p>

    <h3>COMPLIANCE WITH LAWS</h3>
    <p>
      You represent and warrant that:
    </p>
    <ol>
      <li>You have the authority to bind yourself to these Terms of Use;</li>
      <li>Your use of the Website will be solely for purposes that are permitted by these Terms of Use;</li>
      <li>Your use of the Website will not infringe or misappropriate the confidentiality or intellectual property rights of any User or third party; and</li>
      <li>Your use of the Website will comply with all local, provincial and federal laws,rules and regulations, and with all policies posted on the Website.</li>
    </ol>
    <p>
      You must only use the Website for your own lawful purposes, in accordance with these Terms of Use and any notice, policy or condition posted on the Website. You may use the Website on behalf of others or in order to provide services to others but if you do so you must ensure that you are authorized to do so and that all persons for whom or to whom services are provided comply with and accept all these Terms of Use.
    </p>

    <h3>AGE RESTRICTIONS</h3>
    <p>
      Users under the age of 18 are only permitted to access and use the Website while under the direct supervision of a parent or guardian.
    </p>
    
    <h3>GOVERNING LAW AND DISPUTE RESOLUTION</h3>
    <p>
      These Terms of Use and any access to or use of the Website shall be governed by, and construed in accordance with, the laws in force in the Province of Ontario.
    </p>
    <p>
      If any claim, dispute or controversy occurs between STRAWKET LEARNING INC.and a User relating to the interpretation or implementation of any of theprovisions of these Terms of Use, such dispute shall be resolved by private,confidential and binding arbitration. Such arbitration shall be conducted by asingle arbitrator. The arbitrator shall be appointed by agreement of the partiesor, in the absence of an agreement, such arbitrator shall be appointed by a judgeupon the application of either the User or STRAWKET LEARNING INC. Arbitrationshall be held in the Province of Ontario, unless otherwise agreed by the parties.The arbitration procedure to be followed shall be agreed by the parties or, inabsence of an agreement, determined by the arbitrator. The arbitration shallproceed in accordance with the provisions of the Arbitration Act, 1991, SO 1991,c 17. Subject to any right of appeal, the decision arrived at by the arbitrator shallbe final and binding. Judgment upon the award rendered by the arbitrator maybe entered in any court having jurisdiction.
    </p>

    <h3>WAIVER OF CLASS ACTION</h3>
    <p>
      By using the Website, you agree to resolve any claim or dispute arising between you and us on an individual basis, rather than addressing such claim or dispute as part of a group or class. You hereby waive any right you may have to commence or participate in any class action lawsuit commenced against STRAWKET LEARNING INC. or its affiliates related to any claim, dispute or controversy arising from your use of the Website. Where applicable, you hereby agree to opt out of any class proceeding against STRAWKET LEARNING INC. otherwise commenced.
    </p>
    <p>
      The above waiver shall not apply to claims or disputes arising under consumer protection legislation or any other claim or dispute where a waiver of class action lawsuits is unenforceable at law.
    </p>

    <h3>GENERAL TERMS</h3>
    <ol>
      <li><strong>AMENDING THESE TERMS OF USE</strong></li>
      <p>These Terms of Use may be updated and amended from time to time. We reserve the right to change these Terms of Use at any time, and any amended Terms of Use are effective upon posting to the Website. We will make efforts to communicate any changes to these Terms of Use we deem material, in our sole discretion, via email or notifications on the Website. Your continued use of the Website will be deemed to be immediate and unconditional acceptance of any amended Terms of Use, whether or not we deemed the amendments to be material.</p>
      <li><strong>ASSIGNMENT</strong></li>
      <p>We may assign or delegate these Terms of Use, in whole or in part, to any person or entity at any time with or without your consent and without prior notice to you.</p>
      <p>Users may not assign or delegate any rights or obligations under these Terms of Use, without our prior written consent, and any unauthorized assignment and delegation is void.</p>
      <li><strong>NO WAIVER</strong></li>
      <p>No waiver of a provision, right or remedy of this Agreement shall operate as a waiver of any other provision, right or remedy or the same provision, right or remedy on a future occasion.</p>
      <li><strong>NO AGENCY</strong></li>
      <p>The parties to these Terms of Use are independent contractors and are not partners or agents. STRAWKET LEARNING INC. has no fiduciary obligations or professional obligations whatsoever to you arising from these Terms of Use or your use of the Website.</p>
      <li><strong>SEVERABILITY</strong></li>
      <p>In the event that any provision or part of this Agreement is found to be void or invalid by a court of law, the remaining provisions, or parts thereof, shall be construed and remain in full force and effect.</p>
      <li><strong>ENTIRE AGREEMENT</strong></li>
      <p>These Terms of Use, in conjunction with all policies and guidelines available on the Website (including but not limited to any Privacy Policy), incorporated by reference, constitute the entire agreement between you and STRAWKET LEARNING INC. and supersede all prior communications, agreements and understandings, written or oral, with respect to the subject matter of these Terms of Use.</p>
    </ol>

    <h3>QUESTIONS ON THESE TERMS OF USE</h3>
    <p>
      We welcome you to contact us with any questions on these Terms of Use. You can send your questions regarding these Terms of Use to the following email address:<strong>support@strawket.com</strong>
    </p>
    <p>support@strawket.com</p>

    <h3>CONFIRMATION OF AGREEMENT TO TERMS OF USE</h3>
    <p>
      BY PROCEEDING TO USE THE WEBSITE, YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD AND AGREE TO BE BOUND BY THESE TERMS OF USE AND ANY POLICIES AND NOTICES POSTED ON THE WEBSITE.
    </p>
        </div>
      </div>
      </>
      );
    };

    export default TermsConditions;